import axios from "../axios";

const api = {
  getScopeOneConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-one`, config).then(({ data }) => data);
  },

  getScopeTwoConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-two`, config).then(({ data }) => data);
  },

  getScopeThreeConversionFactors(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/conversion-factors/scope-three`, config).then(({ data }) => data);
  }
}

export default api;